import { DeliveryStatusValue, DriverStatusValue, IDriverActiveOrder } from "../models/IDriver";

export const DRIVER_STATUS_META: Record<DriverStatusValue, { label: string; color: string; bg: string }> = {
  Offline:    { label: "Çevrimdışı", color: "#6b7280", bg: "#f3f4f6" },
  Available:  { label: "Müsait",     color: "#15803d", bg: "#dcfce7" },
  OnDelivery: { label: "Teslimatta", color: "#b45309", bg: "#fef3c7" },
};

const DRIVER_STATUSES: DriverStatusValue[] = ["Offline", "Available", "OnDelivery"];

export function normalizeDriverStatus(s?: string | null): DriverStatusValue {
  return DRIVER_STATUSES.find((k) => k.toLowerCase() === (s ?? "").toLowerCase()) ?? "Offline";
}

export const DELIVERY_STATUS_META: Record<DeliveryStatusValue, { label: string; color: string; bg: string; icon: string }> = {
  Assigned:  { label: "Teslim alınacak", color: "#4f46e5", bg: "#eef2ff", icon: "bi-shop" },
  PickedUp:  { label: "Yolda",           color: "#c2410c", bg: "#ffedd5", icon: "bi-bicycle" },
  Delivered: { label: "Teslim edildi",   color: "#15803d", bg: "#dcfce7", icon: "bi-check-circle-fill" },
  Cancelled: { label: "İptal edildi",    color: "#b91c1c", bg: "#fee2e2", icon: "bi-x-circle-fill" },
};

const DELIVERY_STATUSES: DeliveryStatusValue[] = ["Assigned", "PickedUp", "Delivered", "Cancelled"];

export function normalizeDeliveryStatus(s?: string | null): DeliveryStatusValue {
  return DELIVERY_STATUSES.find((k) => k.toLowerCase() === (s ?? "").toLowerCase()) ?? "Assigned";
}

export function formatTime(date: string | Date): string {
  return new Date(date).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" });
}

export function formatRelative(date: string | Date, now: number = Date.now()): string {
  const diffSec = Math.max(0, Math.round((now - new Date(date).getTime()) / 1000));
  if (diffSec < 45) return "az önce";
  const min = Math.round(diffSec / 60);
  if (min < 60) return `${min} dk önce`;
  const hours = Math.round(min / 60);
  if (hours < 24) return `${hours} sa önce`;
  return formatDate(date);
}

export function formatDuration(from: string, to: string): string {
  const min = Math.max(0, Math.round((new Date(to).getTime() - new Date(from).getTime()) / 60000));
  if (min < 60) return `${min} dk`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m ? `${h} sa ${m} dk` : `${h} sa`;
}

export function formatMoney(amount: number, currency?: string | null): string {
  const value = amount.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return `${value} ${currency || "TL"}`;
}

export function collectsAtDoor(order: IDriverActiveOrder): boolean {
  const text = `${order.paymentMethod?.nameTr ?? ""} ${order.paymentMethod?.nameEn ?? ""}`.toLowerCase();
  return ["kapıda", "kapida", "nakit", "cash", "door"].some((k) => text.includes(k));
}

export function hasCoords(lat?: number | null, lng?: number | null): boolean {
  return lat != null && lng != null;
}

export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, "")}`;
}

/**
 * Google Maps yol tarifi. `dir_action=navigate` telefonda rota önizlemesinde beklemeden
 * sesli navigasyonu başlatır (masaüstünde yok sayılır, rota gösterilir).
 */
export function mapsDirectionsUrl(lat: number, lng: number): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving&dir_action=navigate`;
}

export function mapsSearchUrl(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function customerAddressText(order: IDriverActiveOrder): string {
  const a = order.deliveryAddress;
  if (!a) return "";
  return [a.description, a.townNameTr, a.cityNameTr].filter(Boolean).join(", ");
}
